export default class ImageTexte {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {}
}
